import { DialogContent as MUIDialogContent, styled } from '@mui/material';

import { lookoDialogHeaderClassName } from './DialogHeader';

export default styled(MUIDialogContent)({
  [`.${lookoDialogHeaderClassName} + &`]: {
    paddingTop: 16,
    paddingBottom: 16,
  },
});
